// @ts-nocheck
import React from "react";
import { useForm, useFormState } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";

import { Button, Grid, Paper, Typography, Box } from "@mui/material";
import { TaxType, EntityType } from "@soqs/common";
import BOEntityDetails from "./BOEntityDetails";
import { isMobile } from "react-device-detect";
import { Stack } from "@mui/system";

const BOEntitiesList = () => {
  const formstate = useFormState();
  let form = useForm();

  return (
    <Grid size={{ xs: 12 }}>
      <Grid size={{ xs: 12, md: 12 }}>
        {formstate.values?.bo_entities?.length >= 2 && isMobile ? (
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <Typography variant="body1" gutterBottom>
              Should this Trust have more than 2 Entity Beneficiaries, please
              add documentation that could be used to identify them on the
              Suporting Documents Upload page.
            </Typography>
          </Box>
        ) : null}
        <Stack spacing={2} direction={"row"}>
          <Button
            sx={{ display: { xs: "block", md: "none" } }}
            name="AddNamedEntity"
            variant="contained"
            color="primary"
            onClick={() => {
              form.mutators.unshift("bo_entities", {
                bo_entity_key: Date.now().toString(),
                bo_entity_representatives: [],
                bo_entity_type: EntityType.Company,
                bo_entity_taxnumber: "",
                bo_entity_taxtype: TaxType.PIT,
                bo_entity_registration_number: "",
                bo_entity_registered_name: "",
                bo_entity_unnamed_category: undefined,
                bo_entity_unnamed_description: "",
                bo_entity_unnamed: false,
              });
            }}
            disabled={formstate.values?.bo_entities?.length >= 2}
          >
            Add Named Beneficial Owner
          </Button>
          <Button
            sx={{ display: { xs: "block", md: "none" } }}
            name="AddUnnamedEntity"
            variant="contained"
            color="primary"
            onClick={() => {
              form.mutators.unshift("bo_entities", {
                bo_entity_key: Date.now().toString(),
                bo_entity_representatives: [],
                bo_entity_type: EntityType.Company,
                bo_entity_unnamed_description: "",
                bo_entity_unnamed_category: undefined,
                bo_entity_unnamed: true,
              });
            }}
            disabled={formstate.values?.bo_entities?.length >= 2}
          >
            Add Unnamed Beneficial Owner
          </Button>
        </Stack>
        <br />
        {formstate.values?.bo_entities?.length >= 3 ? (
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <Typography variant="body1" gutterBottom>
              Should this Trust have more than 3 Entity Beneficiaries, please
              add documentation that could be used to identify them on the
              Suporting Documents Upload page.
            </Typography>
          </Box>
        ) : null}
        <Stack spacing={2} direction={"row"}>
          <Button
            sx={{ display: { xs: "none", md: "block" } }}
            name="AddNamedEntity"
            variant="contained"
            color="primary"
            onClick={() => {
              form.mutators.unshift("bo_entities", {
                bo_entity_key: Date.now().toString(),
                bo_entity_representatives: [],
                bo_entity_type: EntityType.Company,
                bo_entity_taxnumber: "",
                bo_entity_taxtype: TaxType.PIT,
                bo_entity_registration_number: "",
                bo_entity_registered_name: "",
                bo_entity_unnamed_category: undefined,
                bo_entity_unnamed_description: "",
                bo_entity_unnamed: false,
              });
            }}
            disabled={formstate.values?.bo_entities?.length >= 3}
          >
            Add Named Beneficial Owner
          </Button>
          <Button
            sx={{ display: { xs: "none", md: "block" } }}
            name="AddUnnamedEntity"
            variant="contained"
            color="primary"
            onClick={() => {
              form.mutators.unshift("bo_entities", {
                bo_entity_key: Date.now().toString(),
                bo_entity_representatives: [],
                bo_entity_type: EntityType.Company,
                bo_entity_unnamed_description: "",
                bo_entity_unnamed_category: undefined,
                bo_entity_unnamed: true,
              });
            }}
            disabled={formstate.values?.bo_entities?.length >= 3}
          >
            Add Unnamed Beneficial Owner
          </Button>
        </Stack>
        <br />
        <FieldArray name="bo_entities">
          {({ fields }) =>
            fields.map((name, index) => (
              <div key={fields.value[index].bo_entity_key}>
                <br />
                <Paper
                  variant="outlined"
                  style={{ padding: "2%", paddingTop: "0%" }}
                >
                  <BOEntityDetails name={name} index={index} />
                  <br />
                  <Button
                    name="deleteentity"
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      fields.remove(index);
                    }}
                  >
                    Remove Entity
                  </Button>
                </Paper>
              </div>
            ))
          }
        </FieldArray>
      </Grid>
    </Grid>
  );
};

export default BOEntitiesList;
